document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-custom-order-calculator]').forEach((root) => {
    if (!(root instanceof HTMLElement)) return;

    const form = root.closest('form') || document;
    const widthInput = root.querySelector('[data-co-width]');
    const heightInput = root.querySelector('[data-co-height]');
    const output = root.querySelector('[data-co-estimate]');
    const currencyPrefix = root.dataset.coCurrency || '';

    // A product can lock Width at a fixed value (e.g. products that are only
    // ever sold at a set width) via the section's "Fixed width" setting. When
    // set, there is no editable width input — the fixed value drives the
    // estimate instead, and only Height is read from the form.
    const fixedWidth = parseFloat(root.dataset.coFixedWidth || '');
    const hasFixedWidth = !Number.isNaN(fixedWidth) && fixedWidth > 0;

    if (!hasFixedWidth && !(widthInput instanceof HTMLInputElement)) return;
    if (!(heightInput instanceof HTMLInputElement)) return;
    if (!(output instanceof HTMLElement)) return;

    const qualityInputs = form.querySelectorAll('[data-co-quality]');

    function getPricePerUnit() {
      const checked = form.querySelector('[data-co-quality]:checked');
      if (!(checked instanceof HTMLElement)) return 0;
      return parseFloat(checked.dataset.pricePerSqft || '0') || 0;
    }

    /** @param {number} amount */
    function formatEstimate(amount) {
      const rounded = Math.round(amount);
      return currencyPrefix + rounded.toLocaleString('en-US');
    }

    function recalc() {
      if (!(heightInput instanceof HTMLInputElement) || !(output instanceof HTMLElement)) return;

      const width = hasFixedWidth
        ? fixedWidth
        : widthInput instanceof HTMLInputElement
          ? parseFloat(widthInput.value) || 0
          : 0;
      const height = parseFloat(heightInput.value) || 0;
      const pricePerUnit = getPricePerUnit();

      if (width > 0 && height > 0 && pricePerUnit > 0) {
        output.textContent = formatEstimate(width * height * pricePerUnit);
      } else {
        output.textContent = '—';
      }
    }

    if (!hasFixedWidth && widthInput instanceof HTMLInputElement) {
      widthInput.addEventListener('input', recalc);
    }
    heightInput.addEventListener('input', recalc);
    qualityInputs.forEach((input) => input.addEventListener('change', recalc));

    recalc();
  });

  // "Upload My Own Design" reveals the calculator + file upload block (hidden
  // by default so the standard Add to Cart path stays required-field-free —
  // browsers exempt hidden inputs from constraint validation automatically)
  // and scrolls it into view. Both buttons submit the same <form>.
  document.querySelectorAll('[data-co-reveal-trigger]').forEach((trigger) => {
    const form = trigger.closest('form');
    if (!form) return;

    const revealSectionMaybe = form.querySelector('[data-co-reveal]');
    if (!(revealSectionMaybe instanceof HTMLElement)) return;
    const revealSection = revealSectionMaybe;

    trigger.addEventListener('click', () => {
      revealSection.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      revealSection.scrollIntoView({ behavior: 'smooth', block: 'start' });

      const firstField = revealSection.querySelector('input');
      if (firstField instanceof HTMLElement) firstField.focus({ preventScroll: true });
    });
  });
});
